/* eslint-disable no-secrets/no-secrets */
/* eslint-disable array-callback-return */
import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../../SpaAndWellCommonStyles.module.scss'
import metadata from './Operations.metadata.json5';
import ServiceTable from '../ServiceTable/ServiceTable';

function Operations(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('Operations');
    const modelVM = _.get(submissionVM, pathUpdated);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const operations = ['phystherapist', 'chionstaFie', 'allPieoththaEarNosFie',
        'pieoththaEarNosFie', 'molRemInvCutFie', 'tatPerBodFie', 'skiTagRemInvCutFie',
        'warRemInvCutFie']
    const basic_esthetics = "Basic Esthetics"
    const midrange_esthetics = "Mid-Range Esthetics"
    const highrange_esthetics = "High End Esthetics"
    const misproser_esthetics = "Miscellaneous Professional Services"
    const teaope_esthetics = "Teaching Operations"
    const oth_esthetics = "Other"
    const basic_esthetics_FR = "Soins esthétiques de base"
    const midrange_esthetics_FR = "Soins esthétiques milieu de gamme"
    const highrange_esthetics_FR = "Soins de beauté haut de gamme"
    const misproser_esthetics_FR = "Services professionnels divers"
    const teaope_esthetics_FR = "Activités d’enseignement"
    const oth_esthetics_FR  = "Autre"

    modelVM.value.isValidationReq = true;
    modelVM.value.pswrevTabExps.isValidationReq = true;

    useEffect(() => {
        const estGroAnnRecBasEstFieValue = _.get(modelVM, 'pswrevTabExps.estGroAnnRecBasEstFie.value') !== undefined
            ? _.get(modelVM, 'pswrevTabExps.estGroAnnRecBasEstFie.value') : 0;
        const estGroAnnRecMidEstFieValue = _.get(modelVM, 'pswrevTabExps.estGroAnnRecMidEstFie.value') !== undefined
            ? _.get(modelVM, 'pswrevTabExps.estGroAnnRecMidEstFie.value') : 0;
        const estGroAnnRecHigEndEstFieValue = _.get(modelVM, 'pswrevTabExps.estGroAnnRecHigEndEstFie.value') !== undefined
            ? _.get(modelVM, 'pswrevTabExps.estGroAnnRecHigEndEstFie.value') : 0;
        const estGroAnnRecMisProSerFieValue = _.get(modelVM, 'pswrevTabExps.estGroAnnRecMisProSerFie.value') !== undefined
            ? _.get(modelVM, 'pswrevTabExps.estGroAnnRecMisProSerFie.value') : 0;
        const estGroAnnRecTeaOpeFieValue = _.get(modelVM, 'pswrevTabExps.estGroAnnRecTeaOpeFie.value') !== undefined
            ? _.get(modelVM, 'pswrevTabExps.estGroAnnRecTeaOpeFie.value') : 0;
        const estGroAnnRecOthOpeFieValue = _.get(modelVM, 'pswrevTabExps.estGroAnnRecOthOpeFie.value') !== undefined
            ? _.get(modelVM, 'pswrevTabExps.estGroAnnRecOthOpeFie.value') : 0;
        const estGroAnnRecAllOpeFieValue = _.get(modelVM, 'pswrevTabExps.estGroAnnRecAllOpeFie.value') !== undefined
            ? _.get(modelVM, 'pswrevTabExps.estGroAnnRecAllOpeFie.value') : 0;

        _.set(modelVM, 'pswrevTabExps.estGroAnnRecBasEstFie.value', estGroAnnRecBasEstFieValue);
        _.set(modelVM, 'pswrevTabExps.estGroAnnRecMidEstFie.value', estGroAnnRecMidEstFieValue);
        _.set(modelVM, 'pswrevTabExps.estGroAnnRecHigEndEstFie.value', estGroAnnRecHigEndEstFieValue);
        _.set(modelVM, 'pswrevTabExps.estGroAnnRecMisProSerFie.value', estGroAnnRecMisProSerFieValue);
        _.set(modelVM, 'pswrevTabExps.estGroAnnRecTeaOpeFie.value', estGroAnnRecTeaOpeFieValue);
        _.set(modelVM, 'pswrevTabExps.estGroAnnRecOthOpeFie.value', estGroAnnRecOthOpeFieValue);
        _.set(modelVM, 'pswrevTabExps.estGroAnnRecAllOpeFie.value', estGroAnnRecAllOpeFieValue);
    }, [modelVM]);

    const updateBasicSummaryOfGrossReceipts = () => {
        const pswServiceTabExpsData = _.get(modelVM.value, 'pswserTabExps');
        const basicEstheticsData = pswServiceTabExpsData.filter((dat) => 
            dat.estClaFie === basic_esthetics || dat.estClaFie === basic_esthetics_FR);

        let estGroAnnRecBasEstFieTotal = 0;

        if (basicEstheticsData.length > 0) {
            basicEstheticsData.map((basicData) => {
                if (basicData.estGroAnnRecFie !== undefined) {
                    estGroAnnRecBasEstFieTotal += basicData.estGroAnnRecFie;
                }
            })
            _.set(modelVM, 'pswrevTabExps.estGroAnnRecBasEstFie.value', estGroAnnRecBasEstFieTotal);
        }

        return estGroAnnRecBasEstFieTotal;
    }

    const updateMidRangeSummaryOfGrossReceipts = () => {
        const pswServiceTabExpsData = _.get(modelVM.value, 'pswserTabExps');
        const midRangeEstheticsData = pswServiceTabExpsData.filter((dat) => 
            dat.estClaFie === midrange_esthetics || dat.estClaFie === midrange_esthetics_FR);

        let estGroAnnRecMidEstFieTotal = 0;

        if (midRangeEstheticsData.length > 0) {
            midRangeEstheticsData.map((midData) => {
                if (midData.estGroAnnRecFie !== undefined) {
                    estGroAnnRecMidEstFieTotal += midData.estGroAnnRecFie;
                }
            })
            _.set(modelVM, 'pswrevTabExps.estGroAnnRecMidEstFie.value', estGroAnnRecMidEstFieTotal);
        }

        return estGroAnnRecMidEstFieTotal;
    }

    const updateHighEndSummaryOfGrossReceipts = () => {
        const pswServiceTabExpsData = _.get(modelVM.value, 'pswserTabExps');
        const highEndEstheticsData = pswServiceTabExpsData.filter((dat) => 
            dat.estClaFie === highrange_esthetics || dat.estClaFie === highrange_esthetics_FR);

        let estGroAnnRecHigEndEstFieTotal = 0;

        if (highEndEstheticsData.length > 0) {
            highEndEstheticsData.map((highEndData) => {
                if (highEndData.estGroAnnRecFie !== undefined) {
                    estGroAnnRecHigEndEstFieTotal += highEndData.estGroAnnRecFie;
                }
            })
            _.set(modelVM, 'pswrevTabExps.estGroAnnRecHigEndEstFie.value', estGroAnnRecHigEndEstFieTotal);
        }

        return estGroAnnRecHigEndEstFieTotal;
    }

    const updateMiscellaneousSummaryOfGrossReceipts = () => {
        const pswServiceTabExpsData = _.get(modelVM.value, 'pswserTabExps');
        const miscellaneousProfSerData = pswServiceTabExpsData.filter((dat) => 
            dat.estClaFie === misproser_esthetics || dat.estClaFie === misproser_esthetics_FR);

        let estGroAnnRecMisProSerFieTotal = 0;

        if (miscellaneousProfSerData.length > 0) {
            miscellaneousProfSerData.map((miscData) => {
                if (miscData.estGroAnnRecFie !== undefined) {
                    estGroAnnRecMisProSerFieTotal += miscData.estGroAnnRecFie;
                }
            })
            _.set(modelVM, 'pswrevTabExps.estGroAnnRecMisProSerFie.value', estGroAnnRecMisProSerFieTotal);
        }

        return estGroAnnRecMisProSerFieTotal;
    }

    const updateTeachingSummaryOfGrossReceipts = () => {
        const pswServiceTabExpsData = _.get(modelVM.value, 'pswserTabExps');
        const teachingOperationsData = pswServiceTabExpsData.filter((dat) => 
            dat.estClaFie === teaope_esthetics || dat.estClaFie === teaope_esthetics_FR);

        let estGroAnnRecTeaOpeFieTotal = 0;

        if (teachingOperationsData.length > 0) {
            teachingOperationsData.map((teachingData) => {
                if (teachingData.estGroAnnRecFie !== undefined) {
                    estGroAnnRecTeaOpeFieTotal += teachingData.estGroAnnRecFie;
                }
            })
            _.set(modelVM, 'pswrevTabExps.estGroAnnRecTeaOpeFie.value', estGroAnnRecTeaOpeFieTotal);
        }

        return estGroAnnRecTeaOpeFieTotal;
    }

    const updateOthersSummaryOfGrossReceipts = () => {
        const pswServiceTabExpsData = _.get(modelVM.value, 'pswserTabExps');
        const otherOperationsData = pswServiceTabExpsData.filter((dat) => 
            dat.estClaFie === oth_esthetics || dat.estClaFie === oth_esthetics_FR);

        let estGroAnnRecOthOpeFieTotal = 0;

        if (otherOperationsData.length > 0) {
            otherOperationsData.map((othData) => {
                if (othData.estGroAnnRecFie !== undefined) {
                    estGroAnnRecOthOpeFieTotal += othData.estGroAnnRecFie;
                }
            })
            _.set(modelVM, 'pswrevTabExps.estGroAnnRecOthOpeFie.value', estGroAnnRecOthOpeFieTotal);
        }

        return estGroAnnRecOthOpeFieTotal;
    }

    const updateAllOperationsSummaryOfGrossReceipts = () => {

        const allOpsValue = updateBasicSummaryOfGrossReceipts() +
            updateMidRangeSummaryOfGrossReceipts() +
            updateHighEndSummaryOfGrossReceipts() +
            updateMiscellaneousSummaryOfGrossReceipts() +
            updateTeachingSummaryOfGrossReceipts() +
            updateOthersSummaryOfGrossReceipts()

        return allOpsValue;
    }

    const spaWelVisibility = () => !_.isUndefined(submissionVM.value.lobData.spaAndWellLine.coverables.beauticiansSpa.productsandCoverageSelection.proReqFie)
        && _.get(submissionVM.value, 'lobData.spaAndWellLine.coverables.beauticiansSpa.productsandCoverageSelection.proReqFie') === "SpaWel"

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        serviceTabComponent: {
            data: modelVM.pswserTabExps,
            updateWizardData,
            submissionVM,
            serOffPath: `${pathUpdated}.pswserTabExps`,
            visible: spaWelVisibility()
        },
        estGroAnnRecBasEstFie: {
            value: updateBasicSummaryOfGrossReceipts(),
            readOnly: true,
            visible: spaWelVisibility()
        },
        estGroAnnRecMidEstFie: {
            value: updateMidRangeSummaryOfGrossReceipts(),
            readOnly: true,
            visible: spaWelVisibility()
        },
        estGroAnnRecHigEndEstFie: {
            value: updateHighEndSummaryOfGrossReceipts(),
            readOnly: true,
            visible: spaWelVisibility()
        },
        estGroAnnRecMisProSerFie: {
            value: updateMiscellaneousSummaryOfGrossReceipts(),
            readOnly: true,
            visible: spaWelVisibility()
        },
        estGroAnnRecTeaOpeFie: {
            value: updateTeachingSummaryOfGrossReceipts(),
            readOnly: true,
            visible: spaWelVisibility()
        },
        estGroAnnRecOthOpeFie: {
            value: updateOthersSummaryOfGrossReceipts(),
            readOnly: true,
            visible: spaWelVisibility()
        },
        estGroAnnRecAllOpeFie: {
            value: updateAllOperationsSummaryOfGrossReceipts(),
            readOnly: true,
            visible: spaWelVisibility()
        },
        estheticServicesOpe: {
            visible: spaWelVisibility()
        },
        selectServicesOff: {
            visible: spaWelVisibility()
        },
        summaryOfGross: {
            visible: spaWelVisibility()
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            serviceTabComponent: ServiceTable
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if (changedPath === 'nonFie' && (
                modelVM.value.phystherapist === true ||
                modelVM.value.chionstaFie === true ||
                modelVM.value.allPieoththaEarNosFie === true ||
                modelVM.value.pieoththaEarNosFie === true ||
                modelVM.value.molRemInvCutFie === true ||
                modelVM.value.tatPerBodFie === true ||
                modelVM.value.skiTagRemInvCutFie === true ||
                modelVM.value.warRemInvCutFie === true
            )) {
                return
            }

            if (changedPath === 'nonFie' && (
                    (_.isUndefined(modelVM.value.phystherapist) || modelVM.value.phystherapist === false) &&
                    (_.isUndefined(modelVM.value.chionstaFie) || modelVM.value.chionstaFie === false) &&
                    (_.isUndefined(modelVM.value.allPieoththaEarNosFie) || modelVM.value.allPieoththaEarNosFie === false) &&
                    (_.isUndefined(modelVM.value.pieoththaEarNosFie) || modelVM.value.pieoththaEarNosFie === false) &&
                    (_.isUndefined(modelVM.value.molRemInvCutFie) || modelVM.value.molRemInvCutFie === false) &&
                    (_.isUndefined(modelVM.value.tatPerBodFie) || modelVM.value.tatPerBodFie === false) &&
                    (_.isUndefined(modelVM.value.skiTagRemInvCutFie) || modelVM.value.skiTagRemInvCutFie === false) &&
                    (_.isUndefined(modelVM.value.warRemInvCutFie) || modelVM.value.warRemInvCutFie === false)
                )) {
                    const noneFullPath = `${pathUpdated}.nonFie`;

                    _.set(submissionVM, `${noneFullPath}`, true);
                    updateWizardData(submissionVM);

                    return
                }

            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);

            if (operations.includes(changedPath) && value) {
                const noneFullPath = `${pathUpdated}.nonFie`;

                _.set(submissionVM, `${noneFullPath}`, false);
                updateWizardData(submissionVM);
            } else if (operations.includes(changedPath) && !value) {
                if ((
                    (_.isUndefined(modelVM.value.phystherapist) || modelVM.value.phystherapist === false) &&
                    (_.isUndefined(modelVM.value.chionstaFie) || modelVM.value.chionstaFie === false) &&
                    (_.isUndefined(modelVM.value.allPieoththaEarNosFie) || modelVM.value.allPieoththaEarNosFie === false) &&
                    (_.isUndefined(modelVM.value.pieoththaEarNosFie) || modelVM.value.pieoththaEarNosFie === false) &&
                    (_.isUndefined(modelVM.value.molRemInvCutFie) || modelVM.value.molRemInvCutFie === false) &&
                    (_.isUndefined(modelVM.value.tatPerBodFie) || modelVM.value.tatPerBodFie === false) &&
                    (_.isUndefined(modelVM.value.skiTagRemInvCutFie) || modelVM.value.skiTagRemInvCutFie === false) &&
                    (_.isUndefined(modelVM.value.warRemInvCutFie) || modelVM.value.warRemInvCutFie === false)
                )) {
                    const noneFullPath = `${pathUpdated}.nonFie`;

                    _.set(submissionVM, `${noneFullPath}`, true);
                    updateWizardData(submissionVM);
                }

            }
        },
        [modelVM, operations, pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

Operations.propTypes = wizardProps;
export default withRouter(Operations);
